import { useState,useEffect,useContext } from "react";
import Services from "../../network/Services";
import { isNullUndefine,isValidFuntion } from "../../control/Constant";
import commonLib from "../../control/commonLib";
import moment from "moment";
import { Modal,notification} from "antd";
import { UserContext } from "../../App";
import { Select } from "antd";
const { Option } = Select;

const Compensation = () =>  {
  const [selectedTab, setSelectedTab] = useState("details");
  const [compModel, setCompModel] = useState(1);
  const [allAttorny, setAllAttorny] = useState()
  const [errors, setErrors] = useState({});
  let userId = commonLib.getObjFromStorage("stateObj").userId
  const obj = [{legalCompId: 0,legalStaffUserId:"",compModelTypeId:1,subscriptionId:0,baseSalary:"",bonusPer:"",
  revenueThreshold:"",originatingPer:"",responsiblePer:"",monthlyDraw:"",effectiveDate:"",isActive: true,upsertedBy:userId}]
  const [compensationData, setCompensationData] = useState()
  const [formData, setFormData] = useState(obj);
  const [showConfrimation, setShowConfrimation] = useState(false)
  const [historyDatas, setHistoryDatas] = useState()
  const [userInputId, setUserInputId] = useState()
  const [userDummyData, setUserDummyData] = useState()
  const { setLoader } = useContext(UserContext)


  useEffect(() => {
    getDropDownData()
    getCompModelTypes()
  }, [])

  const getDropDownData = () => {
    setLoader(true)
    let subtenantId = commonLib.getSessionStoarge('subtenantId')
    const getUserlistpromise = Services.getUserListByRoleIdAcadmy(subtenantId, true, "LEGAL");
    getUserlistpromise.then((res) => {
      const response = res?.data?.data
      setAllAttorny(response)
      setLoader(false)

    })
      .catch((err) => {
        // konsole.log("errerr", err);
        setLoader(false)
      }).finally(() => {
        setLoader(false);
      });
  }
  const getCompModelTypes = () => {
    setLoader(true);
    const getUserlistpromise = Services.getCompModelType().then((res) => {
      const response = res?.data?.data
      setCompensationData(response)
      setLoader(false);

    })
      .catch((err) => {
        // konsole.log("errerr", err);
        setLoader(false);
      }).finally(() => {
        setLoader(false);
      });
  }
  const formatDateForInput = (dateString) => {
    return moment(dateString).format("YYYY-MM-DD");
  };

  const noteText = compModel == 1 ? "The Revenue Threshold is the amount of collected revenue after which the bonus percentage will apply. For example, an attorney with a threshold of $22,500 who generates $30,000 will receive bonus on $7,500."
  : "Partners receive a monthly draw of $5,000 that is deducted from final payment. They can earn 25% for origination and 20% for being the responsible attorney on cases. The same attorney can be both the originating and responsible attorney."




  const styles = {
    container: {
      // maxWidth: "1100px",
      margin: "20px auto 50px auto",

    },
    header: {
      // border: "1px solid  #ddd",
      border: "1px solid  #333",
      borderBottom: "none",
      color: "Black",
      padding: "16px",
      fontSize: "16px",
      fontWeight: "bold",
      borderTopLeftRadius: "8px",
      borderTopRightRadius: "8px",
    },
    card: {
      // background: "white",
      // border: "1px solid #333",
      // padding: "15px",
      // borderBottomLeftRadius: "8px",
      // borderBottomRightRadius: "8px",
      // boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    },
    formGroup: {
      marginBottom: "10px",
    },
    label: {
      display: "block",
      marginBottom: "8px",
      fontWeight: "600",
      fontSize: "14px"
    },
    selectInput: {
      width: "100%",
      padding: "10px",
      height: "44px",
      border: "1px solid #333",
      borderRadius: "2px",
    },
    selectInputs: {
      width: "100%",
      border: "1px solid #333",
      borderRadius: "2px",
    },
    tabs: {
      display: "flex",
      marginBottom: "10px",
      borderBottom: "1px solid #333", // Optional: to show separation

    },
    tab: {
      padding: "10px 16px",
      background: "none",
      border: "none",
      cursor: "pointer",
      fontWeight: "600",
      color: "#474747",
      borderBottom: "none",
      fontSize: "14px"

    },
    activeTab: {
      borderBottom: "2px solid #720c20",
      color: " #720c20",
      fontSize: "14px"
    },
    compModel: {
      padding: "15px",
      border: "1px solid #333",
      marginBottom: "10px",
      borderRadius: "2px",
    },
    compLabel: {
      fontWeight: "bold",
      marginBottom: "10px",
      fontSize: "14px"
    },
    radioGroup: {
      display: "flex",
      gap: "20px",
      marginTop: "10px",
      flexWrap: "wrap",
    },
    inputGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: "10px",
    },
    infoBox: {
      backgroundColor: "rgba(114, 12, 32, 0.1)",
      padding: "15px",
      borderRadius: "2px",
      fontSize: "14px",
      marginTop: "10px",
      marginBottom: "20px",
      lineHeight: "1.3",
    },
    buttonGroup: {
      display: "flex",
      justifyContent: "end",
      gap: "15px",
      marginTop: "10px",
      flexWrap: "wrap",
    },
    saveBtn: {
      padding: "10px 24px",
      border: "none",
      cursor: "pointer",
    },

  };

  const handleAttorneyChange = (e) => {

    setFormData(obj)
    setFormData((prev) => {
      const updated = { ...prev[0], ["legalStaffUserId"]: e };
      return [updated];
    });
    setUserInputId(e)
    resetError("legalStaffUserId")
    getUserData(e)
  };

  const resetError = (key) => {
    setErrors(prevErrors => ({
      ...prevErrors,
      [key]: ''
    }));

  }

  const resetFormInput = (numberFields) => {
    setFormData(([current]) => [{
      ...current,
      ...Object.fromEntries(numberFields.map(key => [key, ""])) // or 0 instead of ""
    }]);
  };

  const getUserData = (selectedValue) => {
    setLoader(true);
    let subtenantId = commonLib.getSessionStoarge('subtenantId')
    Services?.getUserCompensationUserData(subtenantId, selectedValue).then((res) => {
      const compensationDetails = res?.data?.data[0]?.compensationDetails || [];
      const activeData = compensationDetails.filter(ele => ele?.isActive);
      setHistoryDatas(compensationDetails);
      setFormData(activeData);
      setUserDummyData(activeData)
      setLoader(false);
      setErrors({})
    }).catch(() => {
      setLoader(false);
    }).finally(() => {
      setLoader(false);
    })
  }
  function isValidDate(dateStr) {
    const date = new Date(dateStr);
    return !isNaN(date.getTime());
  }





  const handleFormSubmit = (key, data) => {
    resetError(key)
    const value = key === "compModelTypeId" ? data : data.target.value
    if (key === "effectiveDate" && isValidFuntion(historyDatas) && isValidDate(value) && isEntryDateValid(value, historyDatas) == false && isEqualDate(value) == true) {
      setFormData((prev) => {
        const updated = { ...prev[0], [key]: '' };
        isValidForm([updated])
        notification.warn({ message: `The effective date you entered is too early. Please choose a date after the existing compensation history.`, placement: 'topRight', });
        return [updated];
      });
      return;
    }
    let eventValue;
    if (key === "compModelTypeId") {
      eventValue = value;
    } else if (key === "effectiveDate") {
      eventValue = value

    } else {
      eventValue = value?.replace(/\D/g, '');
    }
    setFormData(prev => {
      const updated = {
        ...prev[0],
        [key]: eventValue,
        ...(key === "baseSalary" && { revenueThreshold: eventValue * 3 }),
      };
      return [updated];
    });

    if (key == "compModelTypeId") {
      setCompModel(data);
      const numberFields = ["revenueThreshold", "baseSalary", "bonusPer", "effectiveDate"];
      const numberFields1 = ["originatingPer", "responsiblePer", "monthlyDraw", "effectiveDate"]
      const newArray = data == 1 ? numberFields1 : numberFields
      resetFormInput(newArray)
      if ((!isNullUndefine(userInputId)) && (userDummyData[0]?.compModelTypeId == value)) {
        setFormData(userDummyData)
      }
    }
  };

  const handleSubmit = () => {
    if (formData[0]?.legalCompId !== 0 && isValidForm(formData) == true) {
      setShowConfrimation(true)
    } else {
      handleCofrimModal(formData)
    }
  }
  const renderInputField = (label, type, name, placeholder, isDisabled) => {
    const value = name === "effectiveDate" ? formatDateForInput(formData?.[0]?.[name]) : formData?.[0]?.[name] || "";
    const isMoneyField = ["baseSalary", "monthlyDraw", "revenueThreshold"].includes(name);
    const isPercentField = ["bonusPer", "originatingPer", "responsiblePer"].includes(name);

    const getPrefix = () => (isMoneyField ? "$" : "");
    const getSuffix = () => (isPercentField ? "%" : "");

    const inputStyles = {
      ...styles.selectInput,
      paddingLeft: isMoneyField ? "1.5rem" : '0.5rem',
      paddingRight: isPercentField ? "1.5rem" : "0.5rem",
      color: "#474747", 

    };
    // max={name == "effectiveDate" ? getCurrentDate() :""}

    return (
      <div style={styles.formGroup}>
        <label style={styles.label}>{label}</label>
        <div style={{ position: "relative" }}>
          {getPrefix() && (
            <span style={prefixSuffixStyle("left")}>{getPrefix()}</span>
          )}

          <input key={name} type={type} name={name} disabled={isDisabled} placeholder={placeholder} value={value} style={inputStyles} onInput={(e) => handleFormSubmit(name, e)} className="compensation-input" />
          {getSuffix() && (<span style={prefixSuffixStyle("right")}>{getSuffix()}</span>)}
        </div>
        {errors?.[name] && (<p className="text-danger mt-2"><div className="error">{errors[name]}</div></p>)}
      </div>
    );
  };
  function sortDatesDescending(data) {
    return data.sort((a, b) => new Date(b?.effectiveDate) - new Date(a?.effectiveDate));
  }


  const prefixSuffixStyle = (side) => ({
    position: "absolute",
    [side]: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
    color: "#555",
  });


  const isValidForm = (formDatas) => {
    const newErrors = {};

    const numberFields = [{label:"legalStaffUserId", name: "attorney name"},{label:"baseSalary",name:"base salary" },
                          {label:"bonusPer", name: "bonus %" },{label:"effectiveDate",name:"effective date"}];

    const numberFields1 = [{ label:"legalStaffUserId", name: "attorney name"},{ label: "originatingPer", name: "originating %" },
      { label: "responsiblePer", name: "responsible %" },{ label: "monthlyDraw", name: "monthly draw"},{label: "effectiveDate", name: "effective date"}];

    const checkField = formDatas[0]?.compModelTypeId == 1 ? numberFields : numberFields1;
    const invalidFields = checkField.filter((field) => isNullUndefine(formDatas[0][field?.label]) || formDatas[0][field?.label] === "");


    invalidFields.forEach((ele) => {newErrors[`${ele.label}`] = `Please enter ${ele.name}`});

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return false;
    } else {
      return true;
    }
  };
  const handleCofrimModal = (data, isTrue) => {
    setShowConfrimation(false)
    data[0]["UpsertedBy"] = userId

    if (isValidFuntion(formData[0]?.effectiveDate) && isValidFuntion(historyDatas) && (isTrue == true || isEqualDate(formData[0]?.effectiveDate))) {
      if (isEntryDateValid(formData[0]?.effectiveDate, historyDatas) == false) {
        setFormData((prev) => {
          const updated = { ...prev[0], ["effectiveDate"]: '' };
          isValidForm([updated], false)
          notification.warn({ message: `The effective date you entered is too early. Please choose a date after the existing compensation history.`, placement: 'topRight', });

          return [updated];
        });
        return;
      }
    }
    if (isTrue == true) {
      data[0]["legalCompId"] = 0
    }
    if (isValidForm(formData) == true) {
      setLoader(true);
      Services.upsertCompensataionData(data).then((res) => {
        getUserData(res?.data?.data[0]?.legalStaffUserId)
        setLoader(false);
        notification.success({ message: `Attorney compensation ${data[0]?.legalCompId == 0 ? "created" : "updated"} successfully`, placement: 'topRight', });
      }).catch((err) => {
        setLoader(false);
      }).finally(() => {
        setLoader(false);
      })

    }

  }
  const getCurrentDate = () => {
    const today = new Date();
    const currentDate = today.toISOString().split('T')[0];

    return !isNullUndefine(currentDate) ? currentDate : null;
  };
  function isEntryDateValid(entryDate, dataList) {
    const entry = new Date(entryDate).setHours(0, 0, 0, 0);

    return dataList.every(({ effectiveDate }) => {
      const effective = new Date(effectiveDate).setHours(0, 0, 0, 0);
      return entry > effective;
    }) && !dataList.some(({ effectiveDate }) => {
      const effective = new Date(effectiveDate).setHours(0, 0, 0, 0);
      return entry === effective;
    });
  }
  function isEqualDate(entryDate) {
    const entry = new Date(entryDate).setHours(0, 0, 0, 0);
    const exestingDate = historyDatas?.filter(ele => ele?.isActive == true);
    if (exestingDate?.length > 0) {
      const effective = new Date(exestingDate[0].effectiveDate).setHours(0, 0, 0, 0);
      return entry !== effective;
    }

  }



  const header = ["Compensation Type", "Base Salary", "Bonus %", "Revenue Threshold", "Originating %", "Responsible %", "Monthly Draw", "Effective Date"];
  const table1Res = ["compModelTypeName", "baseSalary", "bonusPer", "revenueThreshold", "originatingPer", "responsiblePer", "monthlyDraw", "effectiveDate"];


  const getFormattedDateForCE = (value) => {
    return moment(value).format('MM/DD/YYYY');
  }
  function getValueFromKey(row, key) {
    const value = key.split(".").reduce((acc, part) => acc?.[part], row);

    const isEmpty = isNullUndefine(value) || value === 0;
    if (key === "effectiveDate") {
      return isEmpty ? "-" : getFormattedDateForCE(value);
    }
    if (["baseSalary", "monthlyDraw", "revenueThreshold"].includes(key)) {
      return isEmpty ? "-" : `$ ${value}`;
    }
    if (["bonusPer", "originatingPer", "responsiblePer"].includes(key)) {
      return isEmpty ? "-" : `${value} %`;
    }
    return isEmpty ? "-" : value;
  }

  const isBaseBonus = formData[0]?.compModelTypeId == 1;

  return (
    <>
    <style>{`
      .compensation-input::placeholder { color: #474747 !important; opacity: 1; }
      .ant-modal-footer { border-top: 1px solid #BFBFBF !important; }
    `}</style>
    <div style={styles.container}>
      {/* <div style={styles.header}>Attorney Compensation Configuration</div> */}

      <div style={styles.card}>

          <div style={styles.formGroup}>
            <label style={{ ...styles.label, ...styles.underline }}>Attorney Selection</label>
            <div style={styles.selectInputs}>
              <Select
                showSearch
                placeholder="Select Attorney"
                className="custom-select"
                style={{ width: "100%", border: "none !important", boxShadow: "none !important" }}
                onChange={handleAttorneyChange}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {allAttorny?.map((ele, index) => (
                  <Option key={index} value={ele?.userId || ele?.fullName}>
                    {ele?.fullName}
                  </Option>
                ))}
              </Select>
            </div>

            {errors['legalStaffUserId'] && (<p className="text-danger mt-2"><div className="error">{errors['legalStaffUserId']}</div></p>
            )}
          </div>



        {/* Tabs */}

          <div style={styles.tabs}>
            {["details", "history"].map((tab) => (
              <button key={tab} style={{ ...styles.tab, ...(selectedTab === tab ? styles.activeTab : {}) }} onClick={() => setSelectedTab(tab)}>
                {tab === "details" ? "Compensation Details" : tab === "history" ? "History" : "Preview"}</button>))}
          </div>



      {selectedTab == 'details' ? <>

        {/* Compensation Model */}
        <div style={styles.compModel}>
          <div style={styles.compLabel}>Compensation Model</div>
          <div style={styles.radioGroup}>
            {compensationData?.map((model) => (
              <label key={model.compModelTypeId} style={{ marginRight: "1rem", display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                <input type="radio" name="compModel" value={model.compModelTypeId} checked={compModel === model.compModelTypeId}
                  style={{ accentColor: "#720C20", outlineColor: "#474747", width: "16px", height: "16px", cursor: "pointer", flexShrink: 0 }}
                  onChange={() => handleFormSubmit("compModelTypeId", model.compModelTypeId)} />
                <span style={{ color: "#474747", fontSize: "14px" }}>{model.compModelTypeName}</span>
              </label>
            ))}
          </div>
             {errors['compModelTypeId'] && <p className='text-danger mt-2'><div className="error">{errors['compModelTypeId']}</div></p>}
        </div>

        {/* Input Fields */}
          <div style={styles.inputGrid}>
          {renderInputField(`${isBaseBonus ? "Monthly Base Salary" : "Monthly Originating %"}`,"text",`${isBaseBonus ? "baseSalary" : "originatingPer"}`,"00")}
          {renderInputField(`${isBaseBonus ? "Monthly Bonus %" : "Monthly Responsible %"}`,"text",`${isBaseBonus ? "bonusPer" : "responsiblePer"}`,"00")}
          {renderInputField(`${isBaseBonus ? "Monthly Revenue Threshold" : "Monthly Draw"}`, "text", `${isBaseBonus ? "revenueThreshold" : "monthlyDraw"}`,"00",isBaseBonus ? true : "")}
          {renderInputField("Effective Date", "date", "effectiveDate","")}
        </div>

        {/* Info Box */}
        <div style={styles.infoBox} >
        <p className="mb-0" style={{color:"#720c20"}}>{noteText}</p></div>

        <div style={{...styles.buttonGroup, borderTop: "1px solid #BFBFBF", paddingTop: "24px" }}>
          <button className="add-user-btn" style={styles.saveBtn} onClick={handleSubmit}>Save</button>
        </div>


      </> : <>


     {!isNullUndefine(historyDatas) ? <div className="table-wrapper mt-2 me-1 pb-3" style={{ maxHeight: "calc(100vh - 160px)", overflowY: "auto" }}>
        <table className="table mb-0" style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0, border:"1px solid #BFBFBF"}}>
          <thead style={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>
            <tr>
              {header.map((header, index) => (
                <th key={index} className='fw-bold p-2 text-center shadow-sm' style={{color:"#333"}}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortDatesDescending(historyDatas)?.map((row, index) => (
              <tr key={index}  style={{ borderBottom: "1px solid #dee2e6", cursor: "pointer",backgroundColor : index == 0 ? "rgba(114, 12, 32, 0.1)" : "" }}>
                {table1Res.map((key, i) => {
                  let value = getValueFromKey(row,key);
                  return (
                    <td key={i} style={{ textAlign: "center", padding: "16px", fontWeight: 500, borderRight: "1px solid #dee2e6", fontSize:"13px" }}>
                      {value}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div> : <>
      <p className="text-center">No data available</p>
      </> }

      </>}
   </div>
    </div>
    {showConfrimation && <>
        <Modal
          centered
          visible={showConfrimation}
          onOk={()=>handleCofrimModal(formData,true)}
          onCancel={()=>handleCofrimModal(formData)}
          okText="New Entry"
          cancelText="Correction"
          enforceFocus={false}
          okButtonProps={{
            style: {
              marginTop:"15px",
              marginBottom:"15px",
              backgroundColor: "#720C20",
              borderColor: "#720C20",
              color: "#fff",
              fontWeight: "bold",
              borderRadius: "2px",
              height: "44px",
              minWidth: "100px",
            }
          }}
          cancelButtonProps={{
            style: {
              marginTop:"15px",
              marginBottom:"15px",
              backgroundColor: "#fff",
              borderColor: "#720C20",
              color: "#720C20",
              fontWeight: "bold",
              borderRadius: "2px",
              height: "44px",
              minWidth: "100px",
            }
          }}
        >
          <p style={{fontSize:"14px", color:"#474747"}}>Is this change in the employee's compensation related to:</p>
        </Modal>
    </>}
    </>
  );
}

export default Compensation




